import removeButton from "../../../img/remove_button.svg";
const RemoveButtonIcon = () => (
  <img
    src={removeButton}
    alt="remove button"
    className={"cursor-pointer w-7"}
  />
);
export default RemoveButtonIcon;
